import styled from 'styled-components';

export const MapWrapper = styled.main`
  position: relative;
  width: 100%;
  height: 500px;
`;

export const MapPinMarkerWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9;
`;

export const MapPinMarker = styled.div`
  position: relative;
  left: -50%;

  border-radius: 50% 50% 50% 0;
  border: 10px solid #ff5752;
  width: 30px;
  height: 30px;
  background-color: #fff;
  transform: rotate(-45deg);

  &::after {
    position: absolute;
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    top: calc(50% - 5px);
    left: calc(50% - 5px);
    background-color: #fff;
  }
`;
